<template>
  <router-link
    :to="{ name:'Country Details',
           params: { countryName }
    }"
    :class="$style.borderCountries"
  >
    {{ countryName }}
  </router-link>
</template>

<script>
import { onMounted, ref } from 'vue';
import useFetch from '@/composables/useFetch';

export default {
  props: {
    alphaCode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const fetchData = useFetch();
    const countryName = ref(null);

    onMounted(async () => {
      const { fetchResult } = await fetchData(`https://restcountries.eu/rest/v2/alpha/${props.alphaCode}`);
      countryName.value = fetchResult.value.name;
    });

    return {
      countryName,
    };
  },
};
</script>
<style lang="scss" module>
@import '@/assets/scss/_shared';
.borderCountries {
  display: inline-block;
  background-color: $clr-elements;
  background-color: var(--clr-elements);
  font-size: .874rem;
  font-size: clamp(.75rem, 3wv, .875rem);
  padding: .4em 1.25em;
  min-width: 7rem;
  text-align: center;
  color: inherit;
  text-decoration: none;
  box-shadow: $box-shadow-sm;
  border-radius: $border-radius-sm;
}

</style>
